import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { Wallet } from '@phosphor-icons/react';
import { toast } from 'sonner';
import VendorLedgerSection from '../components/vendor/VendorLedgerSection';

export default function VendorLedgerPage() {
  const { user } = useAuth();
  const [ledger, setLedger] = useState({ entries: [], balance: null });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user?.id) return;
    setLoading(true);
    try {
      const r = await api.get(`/vendors/${user.id}/ledger`);
      setLedger(r.data);
    } catch (err) { toast.error('Load failed'); }
    finally { setLoading(false); }
  }, [user?.id]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-5" data-testid="vendor-ledger-page">
      <div className="flex items-center gap-2 flex-wrap">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <Wallet size={26} weight="duotone" className="text-fuchsia-600" /> My Ledger
        </h1>
      </div>

      {loading ? (
        <div className="p-8 text-center text-sm text-gray-500">Loading...</div>
      ) : (
        <VendorLedgerSection
          vendorId={user?.id}
          vendorName={user?.name}
          entries={ledger.entries || []}
          balance={ledger.balance || {}}
          showBalance
          onRefresh={load}
        />
      )}
    </div>
  );
}
